import { setShowSupplierModal } from '../State/showSupplierModal';

export default () => async (dispatch) => {
  dispatch(setShowSupplierModal(false));
}
